import { _apiV2_get } from "@/app/api2"
import { VizTokenResponse } from "@/app/types"

export async function apiv2_getVizToken(): Promise<VizTokenResponse> {
  return _apiV2_get("/viz/token", { key: "viz_token" })
}
